import { makeStyles } from "@material-ui/core";

export const useStyle = makeStyles((theme) => ({
  containerNoNotification: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      height: "100%",
    },
  },
  noNotification: {
    display: "flex",
    flexFlow: "column nowrap",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    fontSize: theme.typography.pxToRem(18),
    fontFamily: "Inter",
    "& h3": {
      fontWeight: 600,
      marginBottom: 0,
      textAlign: "center",
      fontSize: theme.typography.pxToRem(22),
    },
  },
  secundaryText: {
    fontFamily: "Lato",
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(16),
    width: "70%",
    marginBlock: "0.5rem",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "270px",
    },
  },
  mainText: {
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(16),
    [theme.breakpoints.down("xs")]: {
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
    },
  },
  generalText: {
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(14),
    color: "#333333",
    fontWeight: 400,
    fontStyle: "normal",
    [theme.breakpoints.down("xs")]: {
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
    },
  },
  dateText: {
    fontFamily: "Lato",
    fontSize: theme.typography.pxToRem(12),
  },
  inline: {
    display: "inline",
  },
  listItem: {
    display: "flex",
    flexDirection: "column",
  },
  menuContainer: {
    width: "100%",
  },
}));
